export const actions = {
  checkIn: "LAUNCH_CHECK_IN",
  lineLogin: "LINE_LOGIN"
};

export const dispatchers = {
  handleCheckIn: () => ({
    type: actions.checkIn,
  }),
  handleLineLogin: (accessToken:string, navigateTo: string) => ({
    type: actions.lineLogin,
    accessToken,
    navigateTo
  })
};

export default actions;
